// extracted by mini-css-extract-plugin
export default {"melodyCardCategory":"SQ-z","categoryName":"TQ-z","categoryNameSearchHeader":"UQ-z","categoryContent":"VQ-z","bottomAligned":"WQ-z","image":"XQ-z","imageNoBackground":"YQ-z"};